import axiosInstance from "../helpers/axiosInstance"

const searchGetApplications = (term) => {
  return axiosInstance
    .get("backoffice/Aplicacion/GetList", {
      params: { appName: term },
    })
    .then((response) => {
      if (response.data.status !== "Error") {
        return response.data.results
      } else {
        throw new Error(response.data.errors[0])
      }
    })
}

export default searchGetApplications